<template>
  <form :id="'frm-'+id"
        class="px-3"
        method="post"
        onsubmit="return false"
        ref="form">
    <div :id="id"
         :aria-labelledby="id+'-title'"
         :data-id="name"
         aria-hidden="true"
         class="modal fade"
         data-backdrop="static"
         data-keyboard="false"
         role="dialog"
         tabindex="-1">
      
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header mb-2">
            <h5 :id="id+'-title'" class="modal-title">Sustituir archivo</h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="new_file">Archivo de dictamen</label>
              <div class="custom-file">
                <input data-id="new_file"
                       accept="application/pdf"
                       name="new_file"
                       type="file"
                       id="new_file"
                       ref="new_file"
                       class="custom-file-input"
                       @change="setFile">
                <label for="new_file" class="custom-file-label">Seleccione el archivo de dictamen</label>
              </div>
            </div>
          </div>
          
          <div class="modal-footer flex px-2 shadow-none modal-body-scrolled">
            <button :disabled="sendingForm"
                    class="btn btn-primary mr-2"
                    type="button"
                    @click.prevent="saveFile">
              <template v-if="!sendingForm">Sustituir archivo</template>
              <span v-if="sendingForm"
                    class="spinner-border text-yellow-500 spinner-border-sm"
                    role="status">
                <span class="sr-only">Guardando...</span>
              </span>
            </button>
            <button class="btn btn-secondary"
                    data-dismiss="modal"
                    type="button"
                    :disabled="sendingForm"
                    @click="clearForm(true)">Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import 'jquery-validation'
  
  export default {
    name: 'ModifyDictumFileModal',
    props: {
      id: {
        default: 'modify-dictum-file-modal',
      },
      name: {
        default: 'modify-dictum-file-modal',
      },
      dictum: Number,
      amendment: Object,
    },
    data () {
      return {
        sendingForm: false,
        file: null,
      }
    },
    methods: {
      ...mapActions({
        saveDictumFile: 'amendments/saveDictumFile',
      }),
      
      clearForm () {
        this.file = null
        
        this.$emit('modal-closed')
      },
      
      async saveFile () {
        if (!$(this.$refs.form).valid()) {
          return false
        }
        
        console.log(this.amendment)
        
        const formData = new FormData()
        formData.append('file', this.file)
        formData.append('amendment_id', this.amendment.id)
        formData.append('amendment_type', this.amendment.type.key)
        formData.append('dictum', this.dictum)
        
        this.sendingForm = true
        
        const response = await this.saveDictumFile(formData)
        
        const {
                status,
                error,
                message,
              } = response
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        this.sendingForm = false
        
        this.$emit('file-updated')
        
        $(this.$el).find('.modal').modal('hide')
      },
      
      setFile (e) {
        this.file = e.target.files[0]
      },

      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      }
    },
    computed: {
      ...mapGetters(['user']),
    },
    mounted () {
      const vm = this
      /**
       * Init JQuery validation
       */
      $('#frm-' + vm.id).validate({
        ignore: [],
        highlight: function (element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (label, element) {
          if (element.hasClass('select2-input')) {
            label.insertAfter(element.siblings('span.select2'))
          }
          else {
            label.insertAfter(element)
          }
          
          label.addClass('invalid-feedback')
        },
        rules: {
          new_file: {
            required: true,
            extension: 'pdf',
            maxsize: (vm.isAdmin() ? 5 : 2) * 1024 * 1024,
          },
        },
        messages: {
          new_file: {
            required: 'Seleccione el nuevo archivo.',
            extension: 'El formato del archivo debe ser PDF.',
            maxsize: `El tamaño del archivo no debe superar los ${ vm.isAdmin() ? 5 : 2 } MB.`,
          },
        },
        submitHandler (form) {
          return false
        },
      })
    },
  }
</script>
